// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__vUv3A","col":"styles_col__1Zxdx","fulfillmentStatus":"styles_fulfillmentStatus__1KOV9","emailCol":"styles_emailCol__1COQS"};